import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import { toast } from 'react-toastify';
import logo from '../assets/BTL_LOGO.png';

const roleHome = {
  user: '/user/dashboard', checker: '/checker/dashboard',
  approver: '/approver/dashboard', it_support: '/it/dashboard', admin: '/admin/dashboard',
};

const Login = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const doLogin = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    login(data.token, data.user);
    navigate(roleHome[data.user.role] || '/');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try { await doLogin(form.email, form.password); }
    catch (err) { toast.error(err.response?.data?.message || 'Login failed'); }
    finally { setLoading(false); }
  };


  return (
    <div style={S.page}>
      <div style={S.blob1} />
      <div style={S.blob2} />
      <div style={S.blob3} />
      <div style={S.card}>
          <div style={S.cardLogoWrap}>
            <img src={logo} alt="Logo" style={S.cardLogo} />
          </div>
          <h2 style={S.cardTitle}>Welcome Back</h2>
          <p style={S.cardSub}>Sign in to your account to continue</p>

          <form onSubmit={handleSubmit}>
            <div style={S.field}>
              <label style={S.label}>Email Address</label>
              <input style={S.input} type="email" placeholder="you@company.com"
                value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div style={S.field}>
              <label style={S.label}>Password</label>
              <input style={S.input} type="password" placeholder="Enter your password"
                value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
            </div>
            <button style={{ ...S.btn, opacity: loading ? 0.8 : 1 }} type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In →'}
            </button>
          </form>

          <div style={S.dividerRow}>
            <div style={S.dividerLine} /><span style={S.dividerText}>Or continue with</span><div style={S.dividerLine} />
          </div>

          <a href={`${process.env.REACT_APP_API_URL}/auth/microsoft`} style={S.msBtn}>
            <svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            <span>Sign in with Microsoft</span>
          </a>

      </div>
    </div>
  );
};

const S = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #060d3a 0%, #0d1a6e 45%, #1a0a4a 100%)',
    position: 'relative', overflow: 'hidden', padding: '40px 16px',
  },
  blob1: { position: 'absolute', width: 500, height: 500, borderRadius: '50%', background: 'rgba(79,110,247,0.12)', top: -180, left: -120, filter: 'blur(60px)', pointerEvents: 'none' },
  blob2: { position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'rgba(172,65,104,0.1)', bottom: -140, right: -100, filter: 'blur(60px)', pointerEvents: 'none' },
  blob3: { position: 'absolute', width: 250, height: 250, borderRadius: '50%', background: 'rgba(247,213,6,0.05)', top: '40%', right: '20%', filter: 'blur(50px)', pointerEvents: 'none' },
  card: {
    background: '#fff', borderRadius: 22, padding: '48px 44px',
    boxShadow: '0 32px 100px rgba(6,13,58,0.45)', width: '100%', maxWidth: 440,
    position: 'relative', zIndex: 1,
  },
  cardLogoWrap: { display: 'flex', justifyContent: 'center', marginBottom: 22 },
  cardLogo: { height: 46, objectFit: 'contain' },
  cardTitle: { textAlign: 'center', color: '#0B1554', fontSize: 24, fontWeight: 900, marginBottom: 6, letterSpacing: -0.3 },
  cardSub: { textAlign: 'center', color: '#94a3b8', fontSize: 13.5, marginBottom: 30 },
  field: { marginBottom: 18 },
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 7 },
  input: {
    width: '100%', padding: '12px 16px', border: '1.5px solid #e5e7eb',
    borderRadius: 10, fontSize: 14, color: '#0B1554', background: '#f9fafb',
    boxSizing: 'border-box', transition: 'all 0.2s',
  },
  btn: {
    width: '100%', padding: '14px', marginTop: 6,
    background: 'linear-gradient(135deg, #0d1a6e 0%, #4f6ef7 100%)',
    color: '#fff', border: 'none', borderRadius: 10,
    fontSize: 15, fontWeight: 700, cursor: 'pointer',
    boxShadow: '0 6px 20px rgba(79,110,247,0.4)',
    letterSpacing: 0.3,
  },
  dividerRow: { display: 'flex', alignItems: 'center', gap: 12, margin: '26px 0 18px' },
  dividerLine: { flex: 1, height: 1, background: '#f1f5f9' },
  dividerText: { fontSize: 11, color: '#94a3b8', fontWeight: 700, letterSpacing: 0.8, whiteSpace: 'nowrap' },
  msBtn: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
    width: '100%', padding: '13px', borderRadius: 10,
    border: '1.5px solid #e5e7eb', background: '#fff',
    fontSize: 14, fontWeight: 600, color: '#374151',
    cursor: 'pointer', textDecoration: 'none',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    transition: 'all 0.15s',
  },
};

export default Login;
